// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oHRbI","col":"styles_col__1A2rb"};